import * as React from 'react';
import { memo } from 'react';

const SvgCornersOut = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 33 33", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21.412 6.555h5v5M11.412 26.555h-5v-5M26.412 21.555v5h-5M6.412 11.555v-5h5", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgCornersOut);

export { Memo as default };
